import { makeActionCreator } from 'crazyEditor/redux/helpers';

export const SEND_TO_BACK = 'crazyEditor/element/SEND_TO_BACK';
export const SEND_TO_FRONT = 'crazyEditor/element/SENT_TO_FRONT';
export const SEND_FORWARD = 'crazyEditor/element/SEND_FORWARD';
export const SEND_BACKWARD = 'crazyEditor/element/SEND_BACKWARD';
export const LOCK_ASPECT_RATIO = 'crazyEditor/element/LOCK_ASPECT_RATIO';
export const UNLOCK_ASPECT_RATIO = 'crazyEditor/element/UNLOCK_ASPECT_RATIO';
export const LOCK_ELEMENT = 'crazyEditor/element/LOCK_ELEMENT';
export const UNLOCK_ELEMENT = 'crazyEditor/element/UNLOCK_ELEMENT';

export const lockElementAspectRatio = makeActionCreator(LOCK_ASPECT_RATIO, 'viewMode', 'ids');
export const unlockElementAspectRatio = makeActionCreator(UNLOCK_ASPECT_RATIO, 'viewMode', 'ids');
export const lockElement = makeActionCreator(LOCK_ELEMENT, 'viewMode', 'ids');
export const unlockElement = makeActionCreator(UNLOCK_ELEMENT, 'viewMode', 'ids');
export const sendToFront = makeActionCreator(SEND_TO_FRONT, 'viewMode', 'ids');
export const sendToBack = makeActionCreator(SEND_TO_BACK, 'viewMode', 'ids');
export const sendForward = makeActionCreator(SEND_FORWARD, 'viewMode', 'ids');
export const sendBackward = makeActionCreator(SEND_BACKWARD, 'viewMode', 'ids');
